var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8c0 .27.098.502.294.697a.954.954 0 0 0 .698.294h6.023v6.018c0 .261.097.492.293.691.196.2.429.3.698.3.27 0 .5-.1.692-.3.192-.2.287-.43.287-.69V8.99h6.036a.94.94 0 0 0 .685-.293A.952.952 0 0 0 16 8a.952.952 0 0 0-.294-.697.94.94 0 0 0-.685-.294H8.985V.991A.969.969 0 0 0 8.698.3a.925.925 0 0 0-.692-.3c-.27 0-.502.1-.698.3a.959.959 0 0 0-.293.69v6.02H.992a.954.954 0 0 0-.698.293A.952.952 0 0 0 0 8Z",
    fill: "#014152"
  })));
};

export default SvgPlus;